import { z } from "zod";
/**
 * The sections of the home page, in the order they are laid out. An operator
 * stores which sections they show (`operator.home_sections`); a section left
 * out is hidden, and no stored list means all of them.
 */
export const HOME_SECTIONS = {
    tanks: "Tanks",
    harvests: "Harvests",
    broth: "Broth",
    analytics: "Analytics queue",
};
export const HOME_SECTION_IDS = Object.keys(HOME_SECTIONS);
/** A stored section list: known ids only; a missing id is hidden. */
export const homeSectionsSchema = z.array(z.enum(HOME_SECTION_IDS));
export function isHomeSection(value) {
    return Object.hasOwn(HOME_SECTIONS, value);
}
/**
 * Every section once, in layout order, with whether the operator shows it.
 * Unknown stored ids are ignored, so a section removed from code never breaks
 * a stored list. The stored order means nothing: the layout is fixed.
 */
export function resolveHomeSections(stored) {
    const shown = stored == null ? null : new Set(stored);
    return HOME_SECTION_IDS.map((id) => ({ id, shown: shown == null || shown.has(id) }));
}
//# sourceMappingURL=home-sections.js.map